<template>
  <WeContainer v-if="ready" header="true" v-bind:actions="actions">
    <router-view name="roles" v-bind:key="$route.path"></router-view>
    <WeTable
      v-bind:index="false"
      v-bind:data="list"
      v-bind:columns="columns"
      v-bind:actions="tableActions"
      v-on:on-action="onAction"
      v-on:on-switch="onSwitch"
    ></WeTable>
  </WeContainer>
  <WeLoading v-else />
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
export default {
  name: "List",
  data() {
    return {
      ready: false,
      list: [],
      actions: [
        {
          text: "Yeni Rol",
          path: "roles/new",
        },
      ],
      tableActions: [
        {
          icon: "fas fa-edit",
          class: "btn-outline-primary",
          action: "edit",
        },
        // {
        //   icon: "fas fa-trash",
        //   class: "btn-outline-danger ml-2",
        //   action: "remove",
        // },
      ],
      columns: [{ name: "name", th: "Rol Adı", type: "string" }],
    };
  },
  methods: {
    ...mapActions("role", ["getList", "delete", "isActive"]),
    onAction(data) {
      if (data.key == "remove") {
        this.onDelete(data.row, data.index);
      } else if (data.key == "edit") {
        this.onEdit(data.row);
      }
    },
    onEdit(row) {
      this.$router.replace("roles/detail/" + row.id);
    },
    onDelete(row) {
      let message =
        row.full_name + " adlı kullanıcıyı silmek istediğinize emin misiniz ?";

      this.$swal({
        text: message,
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "İptal",
        confirmButtonText: "Sil",
      }).then((confirm) => {
        if (confirm.isConfirmed) {
          this.delete({
            id: row.id,
            onSuccess: (result) => {
              if (result && result.data && result.data.status !== "error") {
                this.$swal({
                  title: "Kullanıcı Başarıyla Silindi",
                  icon: "success",
                  confirmButtonText: "Tamam",
                });
              } else {
                this.$swal({
                  title: "Kullanıcı Silinemedi",
                  text: result.data.message,
                  icon: "error",
                  confirmButtonText: "Tamam",
                });
              }
            },
          });
        }
      });
    },
    onSwitch(data) {
      this.isActive(data);
    },
  },
  computed: {
    ...mapState(["shared"]),
  },
  mounted() {
    this.list = [];
    this.getList({
      onSuccess: (items) => {
        helper.copy(items, this.list);
        this.ready = true;
      },
    });
  },
};
</script>
